import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LocalStorage } from '../../local-storage.class';
import { ApiService } from '../../services/api/api.service';

@Injectable({
    providedIn: 'root',
})
export class FieldOptionsService {
    private options = {};

    constructor(private apiService: ApiService) {}

    public getOptions(type?: string): Observable<object> {
        const customer = LocalStorage.getCustomer();
        if (!type) {
            type = '';
        }

        const cacheKey = type || customer.customer_type;

        if (typeof this.options[cacheKey] !== 'undefined') {
            return of(this.options[cacheKey]);
        }

        return this.apiService
            .getCallData$<object>('workareas/options', { customerType: type })
            .pipe(tap(options => (this.options[cacheKey] = options)));
    }
}
